<template><div><h1 id="_9-reportingtool" tabindex="-1"><a class="header-anchor" href="#_9-reportingtool"><span>9. Reportingtool</span></a></h1>
<h2 id="_9-1-beschreibung" tabindex="-1"><a class="header-anchor" href="#_9-1-beschreibung"><span>9.1. Beschreibung</span></a></h2>
<p>Die im System vorhandenen Auswertungen und Statistiken decken einen Grossteil der täglichen Informationsbedürfnisse ab. Immer wieder stösst man aber an Grenzen, v.a. bei der Beantwortung von Fragen, die ad hoc auftauchen und auch schnell beantwortet werden sollen. Deshalb ermöglicht funtrade dem Benutzer, analog den Filterpositionen aus einem Set von Gruppierungen auszuwählen und auf diese Weise eigene Auswertungen zusammenzustellen. Die Definition der Auswertungen folgt dabei einem einfachen Raster:</p>
<ol>
<li>
<p>Öffenen des <RouteLink to="/referenz/refs/ft.refdata.rtjob.html" title="Reportingtool">Reportingtools</RouteLink> und Auswahl der zu analysierenden Datenbasis (z.B. Adressen / Aufträge / Artikel)</p>
</li>
<li>
<p>evtl. Eingrenzung der Daten über <RouteLink to="/referenz/refs/ft.refdata.adrfilter.html" title="Personenfilter Kopf">Adressfilter</RouteLink></p>
</li>
<li>
<p><RouteLink to="/referenz/refs/ft.refdata.tbldim.html" title="Dimension">Dimensionen</RouteLink> festlegen (Gruppierungen X-Achse und Y-Achse)</p>
</li>
<li>
<p><RouteLink to="/referenz/refs/ft.refdata.rtresult.html" title="Ergebnistabelle">Ergebniswerte</RouteLink> festlegen (z.B. Anzahl, Wert, Durchschnittswert)</p>
</li>
<li>
<p>Im Job <RouteLink to="/referenz/refs/ft.refproc.rt.html" title="Reportingtool-Auswertung">Reportingtool vorbereiten, drucken</RouteLink> die Ausgabeoptionen festlegen</p>
</li>
<li>
<p>evtl. Einrichten eines <RouteLink to="/referenz/refs/ft.refdata.batch.html" title="Jobs">Hintergrundjobs</RouteLink>, wenn die Auswertung regelmässig erfolgen soll</p>
</li>
</ol>
<p>Für jede Datenbasis sind nur bestimmte Dimensions-Gruppierungen möglich (es ist wohl kaum sinnvoll, Publikationen pro Artikel untersuchen zu wollen). Deshalb ist im System ein festes Set an Gruppierungen pro Datenbasis bereits definiert. Analog den Filterpositionen können diese aber bei Bedarf erweitert werden. So entsteht aufgrund der effektiven Bedürfnisse mit der Zeit ein Set von praxiserprobten Auswertungsmöglichkeiten.</p>
<p>Mit den Gruppierungen wird definiert:</p>
<ol>
<li>
<p>Ob Einzelwerte (diskrete Werte) oder Bereichswerte von/bis (sog. Intervall-Werte) möglich sind.</p>
</li>
<li>
<p>Welche Ergebniswerte anschliessend gewählt werden können (z.B. Anzahl, Umsatz)</p>
</li>
</ol>
</div></template>


